import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Tengo que comprar suplementos caros?',
  answer: 'No, nos enfocamos en comida real y herramientas gratuitas como la respiración.'
}, {
  question: '¿Puedo hacerlo si trabajo fuera de casa?',
  answer: 'Sí, el plan está diseñado para mujeres con agendas ocupadas.'
}, {
  question: '¿Es apto para vegetarianas?',
  answer: 'Sí, el protocolo tiene ajustes para diferentes estilos de alimentación.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-28 bg-white" data-id="element-202">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-203">
        <FadeIn data-id="element-204">
          <div className="text-center mb-12" data-id="element-205">
            <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-206">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-207">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-208">
              <div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-sage-400 bg-sage-50/50' : 'border-cream-300 bg-white hover:border-sage-300'}`} data-id="element-209">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-210">
                  <span className="text-lg font-bold text-charcoal font-sans pr-8" data-id="element-211">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-sage-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-212" />
                </button>

                <AnimatePresence data-id="element-213">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-214">
                      <div className="px-6 pb-5 text-charcoal-light text-lg" data-id="element-215">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}